import type { FunctionComponent, ReactNode } from 'react';
import { useEffect } from 'react';

import { useSessionBalanceConfig } from '../../store/compositeSelectors/useSessionBalanceConfig';
import { useCoreDispatch } from '../../store/CoreStore';
import { useBetSlice } from '../../store/slices/bets/selectors';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { useInitializationSlice } from '../../store/slices/initialization/selectors';
import { popupActions } from '../../store/slices/popup/slice';
import { PopupType } from '../popup/types';

// This is a component that triggers session balance session popup TODO: find a better way to handle it
// Solution needs to cover following corner case:
// When player has 0 balance, the popup is not displayed.
// If he updates the balance in lobby (in other tab, while still in game), the balance will be updated and popup should be displayed

export const SessionBalanceConnected: FunctionComponent = (): ReactNode => {
  const sessionBalance = useSessionBalanceConfig();
  const dispatch = useCoreDispatch();
  const balance = useGameStateSlice.balance()?.amount;
  const minBet = useBetSlice.getMinBet();
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();
  const compliance = useConfigSlice.compliance();
  const sessionBalanceWasSet = compliance?.sessionBalanceWasSet;

  useEffect(() => {
    if (isReadyToRender && !sessionBalanceWasSet && sessionBalance && balance !== undefined && balance > minBet) {
      dispatch(popupActions.pushPopup(PopupType.SessionBalance));
    }
  }, [sessionBalance, balance, minBet, dispatch, isReadyToRender, sessionBalanceWasSet]);

  return null;
};
